import * as React from "react";

function SvgNoora(props, ref) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="-50 0 624 624"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...{ ...props, ref }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M996 270v234h120V237c0-71.245-57.76-129-129-129-39.77 0-75.337 17.997-99 46.291V120H768v384h120V270c0-29.823 24.177-54 54-54s54 24.177 54 54zm564 42c0 112.666-94.02 204-210 204s-210-91.334-210-204 94.02-204 210-204 210 91.334 210 204zm-300 1.121c0 56.778 37.66 94.879 88.87 94.879 51.97 0 91.13-40.342 91.13-96.374 0-57.525-39.92-95.626-91.13-95.626-51.97 0-88.87 39.595-88.87 97.121zM2256 219c-7.6-2.263-15.66-3-24-3-46.39 0-84 37.608-84 84v204h-120V120h120v34.291c23.66-28.294 59.23-46.291 99-46.291 3.03 0 6.03.104 9 .309V219zm189 297c44.49 0 85.28-17.702 117-47.133V504h120V120h-120v35.133C2530.28 125.702 2489.49 108 2445 108c-101.07 0-183 91.334-183 204s81.93 204 183 204zm25.87-108c-51.21 0-88.87-38.101-88.87-94.879 0-57.526 36.9-97.121 88.87-97.121 51.21 0 91.13 38.101 91.13 95.626 0 56.032-39.16 96.374-91.13 96.374zM1794 516c115.98 0 210-91.334 210-204s-94.02-204-210-204-210 91.334-210 204 94.02 204 210 204zm-1.13-108c-51.21 0-88.87-38.101-88.87-94.879 0-57.526 36.9-97.121 88.87-97.121 51.21 0 91.13 38.101 91.13 95.626 0 56.032-39.16 96.374-91.13 96.374zM220.6 258.955L48 48v504h216V380.537a192.001 192.001 0 00-43.4-121.582zM528 72H312v171.463a192.001 192.001 0 0043.4 121.582L528 576V72z"
        fill="#FF0476"
      />
    </svg>
  );
}

export default React.forwardRef(SvgNoora);
